export function findLast<T>(
  array: Array<T>,
  predicate: (value: T, index: number, obj: T[]) => boolean,
): T | undefined {
  let cursor = array.length

  while (cursor--) {
    if (predicate(array[cursor], cursor, array)) {
      return array[cursor]
    }
  }

  return undefined
}
